import update from 'immutability-helper';
import { USER_ORDERS } from '../types';

export default function orders(state = [], action) {
  switch (action.type) {
    case 'USER_ORDERS':
      return action.orders;
    default:
      return state;
  }
}
